export default __webpack_public_path__ + "static/business-growth-30f5bcd2885c6efd90f37733fdf2d0d6.gif";